/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CaseStatusType = {
    /**
    * Proposal Created
    */
    PROPOSAL_CREATED: 'PROPOSAL_CREATED',
    /**
    * Material Distributed
    */
    MATERIAL_DISTRIBUTED: 'MATERIAL_DISTRIBUTED',
    /**
    * Contract Distributed
    */
    CONTRACT_DISTRIBUTED: 'CONTRACT_DISTRIBUTED'
} as const;
export type CaseStatusType = typeof CaseStatusType[keyof typeof CaseStatusType];


export function instanceOfCaseStatusType(value: any): boolean {
    for (const key in CaseStatusType) {
        if (Object.prototype.hasOwnProperty.call(CaseStatusType, key)) {
            if (CaseStatusType[key as keyof typeof CaseStatusType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CaseStatusTypeFromJSON(json: any): CaseStatusType {
    return CaseStatusTypeFromJSONTyped(json, false);
}

export function CaseStatusTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseStatusType {
    return json as CaseStatusType;
}

export function CaseStatusTypeToJSON(value?: CaseStatusType | null): any {
    return value as any;
}

export function CaseStatusTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): CaseStatusType {
    return value as CaseStatusType;
}

